import $ from 'jquery';

import './UploadButton.scss';
import template from './UploadButton.vhtml';

export default {
	name: 'UploadButton',
	template: template,
	props: {
		name: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			default: 'Upload',
		},
		required: {
			type: Boolean,
			required: false,
		},
		multiple: {
			type: Boolean,
			required: false,
		},
	},
	data: () => ({
		selectedFiles: [],
	}),
	methods: {
		selectFile(event) {
			if (event.target.files) {
				this.selectedFiles = event.target.files;
			} else {
				// Hack for IE9
				this.selectedFiles = [{ name: event.target.value.split('\\').pop() }];
			}
		},
		showUploadDialog() {
			$('input[type=file]', this.$el).trigger('click');
		},
	},
	computed: {
		formatedLabel: (vm) => {
			if (vm.selectedFiles.length === 0) {
				return vm.label;
			} else if (vm.selectedFiles.length === 1) {
				return vm.selectedFiles[0].name || vm.label;
			} else {
				return `${vm.selectedFiles.length} files selected`;
			}
		},
	},
	watch: {
		selectedFiles(newFile, old) {
			this.$emit('files', newFile);
		},
	},
};
